import { TextAlign } from './text-aligh';
var TextAlignHelper = /** @class */ (function () {
    function TextAlignHelper() {
    }
    TextAlignHelper.isAlignLeft = function (align) {
        return align === TextAlignHelper.AlignLeft;
    };
    TextAlignHelper.isAlignCenter = function (align) {
        return align === TextAlignHelper.AlignCenter;
    };
    TextAlignHelper.isAlignRight = function (align) {
        return align === TextAlignHelper.AlignRight;
    };
    TextAlignHelper.toEnum = function (align) {
        switch (align) {
            case TextAlignHelper.AlignLeft:
                return TextAlign.Left;
            case TextAlignHelper.AlignCenter:
                return TextAlign.Center;
            case TextAlignHelper.AlignRight:
                return TextAlign.Right;
            default:
                throw new Error('Unknown TextAlign:' + align);
        }
    };
    TextAlignHelper.AlignLeft = 'left';
    TextAlignHelper.AlignCenter = 'center';
    TextAlignHelper.AlignRight = 'right';
    return TextAlignHelper;
}());
export { TextAlignHelper };
